// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a9d96d {
  padding-inline-end: 8px;
}
.f02d4b {
  display: flex;
  align-items: center;
  max-width: 200px;
}
.a88e6e {
  color: var(--base-text-meta);
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/DropDown/components/DropDownItem/DropDownItem.css"],"names":[],"mappings":"AAAA;EAEU,uBAAuB;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B","sourcesContent":[".a9d96d {\n  -webkit-padding-end: 8px;\n          padding-inline-end: 8px;\n}\n.f02d4b {\n  display: flex;\n  align-items: center;\n  max-width: 200px;\n}\n.a88e6e {\n  color: var(--base-text-meta);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
